import { Component, Input, OnInit } from '@angular/core';
import { DateService } from 'src/app/services/date.service';
import { ComplementInformationEnum, ComplementInformationSignEnum, SignalingTypeEnum, VerticalSignalizationTypeEnum } from 'src/enumerators';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css']
})
export class TableComponent implements OnInit {
  @Input() list: Array<any>;
  @Input() columns: Array<{ name: string, sortIcon: string, variable: string, nameOnly: boolean }> = [];

  complementInformationType = ComplementInformationEnum;
  verticalSignTypeEnum = VerticalSignalizationTypeEnum;
  typeSignEnum = SignalingTypeEnum;
  today = new Date();

  constructor(
    public dateService: DateService,
  ) { }

  ngOnInit(): void {
    console.log(this.list)
    console.log(this.columns)
  }

  // Retorna qual é o tipo da informação complementar sabendo qual é o tipo da placa WARNING/REGULATION
  complementType(item): ComplementInformationSignEnum {
    if (item.complementInformationType == ComplementInformationEnum.Additional) {
      if (item.verticalType == VerticalSignalizationTypeEnum.Warning) {
        return ComplementInformationSignEnum.AdditionalWarning;
      } else {
        return ComplementInformationSignEnum.AdditionalRegulation;
      }
    } else {
      if (item.verticalType == VerticalSignalizationTypeEnum.Warning) {
        return ComplementInformationSignEnum.IncorporatedWarning;
      } else {
        return ComplementInformationSignEnum.IncorporatedRegulation;
      }
    }
  }
}
